var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTripadvisor = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 25,
    width: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1 0H22C23.6 0 25 1.4 25 3.1V22c0 1.7-1.4 3.1-3.1 3.1H3A3.1 3.1 0 0 1 0 21.9V3C0 1.4 1.4 0 3.1 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.6c-2.6 0-4.6.7-6.5 2.6H2.7s0 1 1.3 1.4c-.5.7-1.3 2.1-1.3 3.2 0 2.7 1.9 4.6 4.6 4.6 1.5 0 3-.9 3.9-2l1.3 2 1.3-2c.9 1.1 2.4 2 4 2 2.6 0 4.5-2 4.5-4.6 0-1-.8-2.4-1.3-3.3 1.3-.3 1.3-1.3 1.3-1.3H19c-2-2-3.9-2.6-6.5-2.6zm0 .7c3.3 0 5.2 2 5.2 2-2.6 0-5.2 3.2-5.2 6.5 0-3.3-2.6-6.6-5.2-6.6 0 0 2-2 5.2-2zm-5.2 3.2a3.3 3.3 0 1 1 0 6.6 3.3 3.3 0 0 1 0-6.6zm10.4 0a3.3 3.3 0 1 1 0 6.6 3.3 3.3 0 0 1 0-6.6zM7.3 12a2 2 0 1 0 0 3.9 2 2 0 0 0 0-4zm10.4 0a2 2 0 1 0 0 3.9 2 2 0 0 0 0-4zm-10.4.6a1.3 1.3 0 0 1 0 2.6 1.3 1.3 0 1 1 0-2.6zm10.4 0a1.3 1.3 0 0 1 0 2.6 1.3 1.3 0 0 1 0-2.6zm-10.4.6a.6.6 0 1 0 0 1.3.6.6 0 0 0 0-1.3zm10.4 0a.6.6 0 1 0 0 1.3.6.6 0 0 0 0-1.3z",
    fill: "#0b0002"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTripadvisor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tripadvisor.529e8f3c.svg";
export { ForwardRef as ReactComponent };